import { render, staticRenderFns } from "./PageMercuriales.vue?vue&type=template&id=86643516&"
import script from "./PageMercuriales.vue?vue&type=script&lang=js&"
export * from "./PageMercuriales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports